import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from 'src/app/Service/auth.service';

@Component({
    selector: 'aboutus-popup',
    template: `
    <div class="modal-lg">
        <div class="modal-content">
            <div class="modal-body bios-modal-body">
                <button type="button" (click)="onCancel.emit(true)" class="btn-close" data-bs-dismiss="modal" aria-label="Popup close"></button>
                <div class="brief-bios-wrapper developer-bios d-flex align-items-center mbl-column">
                    <div class="bios-image">
                        <img src={{logoInfo.image}} alt={{logoInfo.name}}>
                    </div>
                    <div class="bios-text">
                        <h3></h3>
                        <p>{{logoInfo.description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>`,
    styleUrls: ['../aboutus.component.css'],
    standalone: false
})
export class AboutUsPopUpComponent {
    @Output() onCancel = new EventEmitter();
    @Input() logoInfo: any = [];
    constructor(public auth: AuthService) { }
    
}
